// extracted by css-extract-rspack-plugin
export default {"container":"SubIssueTypeIndicator-module__container__Op12o"};